import { projectClient } from '../../client/client';

export const application = {
  list: projectClient('/application').get,
  create: projectClient('/application').post,
  get: projectClient('/application/{id}').get,
  delete: projectClient('/application/{id}').delete,
  update: projectClient('/application/{id}').patch,
  revokeAccessToken: projectClient('/application/{id}/revoke-access-token').post,
  revokeRefreshToken: projectClient('/application/{id}/revoke-refresh-token').post,
  rotateSecret: projectClient('/application/{id}/rotate-secret').post,
};
